import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getData } from '@yme/api';
import { ArrowForward } from '@yme/assets/icons';
import { Button, GHOST_VARIANT, LEADING_ICON, SIZE_44 } from '@yme/atoms/button';
import { Col, Container, Row } from '@yme/atoms/grid';
import { InfoBlockEmptyResults } from '@yme/atoms/info-block-empty-results';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { useWindowSize } from '@yme/common/hooks';
import { ColStyled } from '@yme/components/Destinations/ExperienceGrid/styled';
import { PartnerCard } from '@yme/components/Destinations/PartnersGrid/components/PartnerCard';
import { IndentWrapper } from '@yme/components/Separator';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { CardsPerPage, GET_PARTNERS_BY_ROOT_PATH } from './constants';
export function PartnersGrid({ experiencesRootPath, detailsPageUrl, isRemoveBottomIndent, }) {
    const [partners, setPartners] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const isRightToLeft = useSelector(getRTL);
    const { t } = useTranslation();
    const { isMobileView, isInfiniteDesktopView } = useWindowSize();
    useEffect(() => {
        if (!experiencesRootPath)
            return;
        const getPartnersByRoot = async () => {
            try {
                setIsLoading(true);
                const response = await getData(`${GET_PARTNERS_BY_ROOT_PATH}${experiencesRootPath}`);
                const partnersData = response.data?.partnerList?.items ?? [];
                setPartners(partnersData);
            }
            catch (error) {
            }
            finally {
                setIsLoading(false);
            }
        };
        getPartnersByRoot();
    }, [experiencesRootPath]);
    const cardsPerPage = isInfiniteDesktopView ? CardsPerPage.DESKTOP : CardsPerPage.MOBILE;
    const slicedPartners = useMemo(() => partners.slice(0, cardsPerPage * page), [partners, cardsPerPage, page]);
    const isShowLoadMoreBtn = slicedPartners.length !== partners.length;
    const handleLoadMore = useCallback(() => {
        setPage((prev) => prev + 1);
    }, []);
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent, isRightToLeft: isRightToLeft },
        React.createElement(Container, { pt: "32px", lgPt: "48px" },
            React.createElement(Row, null, slicedPartners.length ? (slicedPartners.map((item) => (React.createElement(ColStyled, { key: item.partnerName, md: 4, lg: 4 },
                React.createElement(PartnerCard, { cardData: item, detailsPageUrl: detailsPageUrl }))))) : (React.createElement(InfoBlockEmptyResults, { titleEmptyResults: t('destinations_noPartnersFound_label'), descriptionEmptyResults: t('destinations_refreshPage_label'), isFullWidth: true }))),
            isShowLoadMoreBtn && (React.createElement(Row, { mb: "54px" },
                React.createElement(Col, { justifyContent: "center", display: "flex" },
                    React.createElement(Button, { width: isMobileView ? '100%' : 'auto', buttonVariant: GHOST_VARIANT, hasIconButton: LEADING_ICON, size: SIZE_44, iconComponent: ArrowForward, iconRotate: 90, onClick: handleLoadMore, isRightToLeft: isRightToLeft, label: t('common_loadMore_label'), title: t('common_loadMore_label') }))))),
        React.createElement(SpinnerLoader, { isLoading: isLoading, fullWidth: true })));
}
PartnersGrid.displayName = 'PartnersGrid_AEMComponent';
